/* eslint-disable camelcase */

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_go_beyond_physical_practice_of_yoga_with_our_robust_library_of_courses_articles_and_e_books: Phrase =
  locale => {
    const en = `Go beyond the physical practice of yoga with our robust library of courses, articles and e-books.`;
    const phrases: { [key: string]: undefined | string } = {
      en,
      es: `Ve más allá de la práctica física del yoga con nuestra amplia biblioteca de cursos, docuserie, artículos y libros electrónicos.`,
    };
    return phrases[locale] || en;
  };
